import { useParams } from 'react-router-dom';
import { Button } from 'antd';

import { initSnapSuccessAction, snapStore } from 'containers/Snaps/Snap/store';

import { usePutRequest, useUserRole } from 'hooks';

import { SnapDetails } from 'codegen';

export const ReprocessButton = () => {
  const isReprocessingAllowed = snapStore((state) => state.snapBooleanStatuses.isReprocessingAllowed);

  const { snapId } = useParams();

  const [handleIssuance, { loading }] = usePutRequest<SnapDetails>({
    url: `/snaps/${snapId}`,
    options: {
      onSuccess: ({ data }) => initSnapSuccessAction(data),
    },
  });

  const { isAdmin } = useUserRole();

  if (!isAdmin || !isReprocessingAllowed) {
    return null;
  }

  return (
    <Button
      size='small'
      type='primary'
      loading={loading}
      onClick={() => handleIssuance()}
    >
      Reprocess
    </Button>
  );
};
